import type { RoutersConfigMap } from '@wix/thunderbolt-ssr-api'
import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { LocationWixCodeSdkSiteConfig } from '../types'

const locationWixCodeSdkSiteConfig: SiteConfigFn<LocationWixCodeSdkSiteConfig> = ({ api, funcLib }) => {
	const shouldLoadSiteFeature = api.features.isActive('platform')

	const routersConfigMap = api.rendererModel.getRouters()?.configMap as RoutersConfigMap
	const urlMappingsStr = api.rendererModel.getUrlMappings() ?? 'null'
	const urlMappings = funcLib.parseJSON(urlMappingsStr)

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig: shouldLoadSiteFeature,
		siteConfig: shouldLoadSiteFeature ? { routersConfigMap, urlMappings } : null,
	}
}

const name = 'locationWixCodeSdk'

export const config = { site: locationWixCodeSdkSiteConfig, reactNativeSite: locationWixCodeSdkSiteConfig, name }
